import { createFileRoute } from '@tanstack/react-router';
import PersonalDataPage from '@/features/resume-builder/personal-data';

export const Route = createFileRoute('/perfil/curriculo/dados-pessoais')({
  component: PersonalDataPage,
});
